<template>
  <v-dialog v-model="dialog" persistent width="70%">    
    <v-card>
      <v-container>
        <v-card-title>Travel Party Members
          <v-col cols="1" class="pr-2">
            <btn_audit table="hogs" :encrid="huov.huov_encrid" :size=30 tooltip="audit of travelparty members"/>
          </v-col>
        </v-card-title>
        <v-form ref="huovTravelParty">
          <v-container>
            <v-row cols="12" dense>
              <v-col cols="3" class="pa-1"><label>First name</label></v-col>
              <v-col cols="2" class="pa-1"><label>Last name</label></v-col>
              <v-col cols="1" align="center" class="pl-8">M</v-col>
              <v-col cols="1" class="pa-1"><label>Date of birth</label></v-col>
              <v-col cols="1" class="pa-1"><label>Cat. / Age</label></v-col>
              <v-col cols="1" class="pa-1"><label>Doc. type</label></v-col>
              <v-col cols="2" class="pa-1"><label>Document number</label></v-col>
            </v-row>
            <v-row colls="11" dense>
              <v-col cols="11">
            <v-divider></v-divider>
          </v-col>
            </v-row>
            <div class="br_small"></div>
            <v-row cols="12" v-for="(person, idx) in huov.hogs" :key="idx" dense>
              <v-col cols="3" class="pa-1">
                <v-text-field v-model="person.hogs_voornaam" label="" dense></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-layout justify-start>
                <v-text-field v-model="person.hogs_naam" label="" dense></v-text-field>
                <v-spacer></v-spacer>
                <v-checkbox v-model.lazy="person.hogs_hoofd_gast" label="" dense hide-details class="shrink pr-3" v-on:click="setMainBooker(idx)"></v-checkbox> 
              </v-layout>
              </v-col>
              <v-col cols="1" class="">
                <v-text-field v-model.lazy="person.hogs_geb_dat" :value="refactorDate(person)" label="" dense v-bind:rules="hogs_geb_datRules"></v-text-field>
              </v-col>
              <v-col cols="1" style="display: flex; flex-direction: row; justify-content:space-between !important;">                
                <v-text-field :value="person.hogs_age_cat" label="" dense></v-text-field>
                <v-text-field v-if="calculateAge(idx)>''" :value="`${calculateAge(idx)}`" label="" readonly dense class="def" :class="{'caterror': calculateAge(idx)==='CAT !'}"></v-text-field>
                <v-text-field v-else value="?" label="" readonly dense class="def"></v-text-field>
              </v-col>
              <v-col cols="1" class="pa-1">
                <v-select v-model.lazy="person.hogs_id_type" label="" single-line :items="id_codekeuzes" item-value="code" item-text="desc" dense></v-select>
              </v-col>
              <v-col cols="2" class="pa-1">
                <v-text-field v-model="person.hogs_id_nr" label="" dense></v-text-field>
              </v-col>

              <!--place action buttons here (clear and delete)-->
              <v-col cols="1" class="pa-1">
                <v-layout right-justify>
                  <v-btn icon x-small v-on:click="clearItem(idx)" class="margin-btn"><v-icon>mdi-close</v-icon></v-btn>
                </v-layout>
              </v-col>
          
            </v-row>
          </v-container>
          <div class="br_small"></div>
          
          <div v-if="this.huov.feratel_used_fake_travelparty">
            <v-row dense no-gutters>
              <v-col cols="12" class="pl-4  mt-1 warning">
                <span class="white--text">
                  <v-icon medium class="mr-2 mt-1 mb-1" color="white">mdi-alert-outline</v-icon>Travelparty sent to Feratel with (supplemented) fake information.
                </span>
              </v-col>
            </v-row>
          </div>

          <div v-if="this.huov.Feratel_guid">
            <v-row dense no-gutters>
              <v-col cols="8" class="pl-4 mt-1 info">
                <span class="white--text">
                  <v-icon medium class="mr-2 mt-1 mb-1" color="white">mdi-account-file-outline</v-icon>Feratel preregistration done: {{this.huov.Feratel_guid}}
                </span>
              </v-col>
              <v-col cols="4" class="pl-4 mt-1 info text-right">
                <v-btn v-if="!this.huov.Feratel_mblattnr" x-small color="primary" class="mt-1 mr-4" @click="updFeratel('convert'); loader = 'loading'" :loading="loading">Convert to registration</v-btn>
                <v-dialog v-if="!this.huov.Feratel_mblattnr" v-model="cancelpreregdialog" width="500" >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="red lighten-2 mt-1 mr-4"  x-small dark v-bind="attrs" v-on="on" :loading="loading">
                      Cancel 
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                      Are you sure you want to cancel?
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="updFeratel('cancel_pre'); loader = 'loading'; cancelpreregdialog = false">Yes</v-btn>
                      <v-btn color="secondary" @click="cancelpreregdialog = false">NO</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row> 
          </div>
          <div v-if="this.huov.Feratel_betriebnr !== ''">
          <v-row dense no-gutters>
              <v-col v-if="this.huov.feratel_checks !== 'Complete'" cols="12" class="pl-4 mt-1 warning">
                <span class="white--text">
                  <v-icon medium class="mr-2 mt-1 mb-1" color="white">mdi-alert-outline</v-icon>Feratel checks: {{this.huov.feratel_checks}}
                </span>
              </v-col>
              <v-col v-else cols="12" class="pl-4 mt-1 success">
                <span class="white--text">
                  <v-icon medium class="mr-2 mt-1 mb-1" color="white">mdi-check-circle-outline</v-icon>Feratel checks: {{this.huov.feratel_checks}}
                </span>
              </v-col>
            </v-row>
          </div>
          <div v-if="this.huov.Feratel_mblattnr">
            <v-row dense no-gutters>
              <v-col cols="6" class="pl-4 mt-1 info">
                <span class="white--text">
                  <v-icon medium class="mr-2 mt-1 mb-1" color="white">mdi-account-file-text-outline</v-icon>Feratel registration done: {{this.huov.Feratel_mblattnr}}
                    <v-icon small v-if="this.huov.feratel_used_fake_travelparty" color="orange">mdi-alert-outline</v-icon>
                </span>
              </v-col>

              <v-col cols="6" class="pl-4 mt-1 info text-right">
                <v-btn v-if="this.huov.feratel_registration && this.huov.feratel_guestcard == 'VisitorRegistrationSentManually' && !this.huov.feratel_guestcard_processed" x-small color="primary" class="mt-1 mr-4" :href="this.huov.feratel_registration_printlink" target="_blank" :loading="loading">Print Visitor registration form</v-btn>
                <v-btn v-if="this.huov.feratel_registration && (this.huov.feratel_guestcard == 'GuestcardsSentManuallyViaFeratel' || this.huov.feratel_guestcard == 'GuestcardsSentManuallyViaEmail') && !this.huov.feratel_guestcard_processed" x-small color="primary" class="mt-1 mr-4" :href="this.huov.feratel_guestcard_printlink" target="_blank" :loading="loading">Print Guest cards</v-btn>
                <v-btn v-if="this.huov.feratel_extra" x-small color="primary" class="mt-1 mr-4" @click="updFeratel('departure'); loader = 'loading'" :loading="loading">Finalize registration</v-btn>
                <v-dialog v-if="this.huov.feratel_registration" v-model="cancelregdialog" width="600" >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="red lighten-2 mt-1 mr-4"  x-small dark v-bind="attrs" v-on="on" :loading="loading">
                      Cancel 
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                      Are you sure you want to Cancel this registration?
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="updFeratel('cancel'); loader = 'loading'; cancelregdialog = false">Yes</v-btn>
                      <v-btn color="secondary" @click="cancelregdialog = false">No</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row> 
          </div>
          <div v-if="this.huov.Feratel_mblattnr == '' && this.huov.Feratel_guid == '' && this.huov.feratel_registration && this.huov.Feratel_betriebnr !== ''">
            <v-row dense no-gutters>
              <v-col cols="4" class="pl-4 mt-1 info">
                <span class="white--text">
                  <v-icon medium class="mr-2 mt-1 mb-1" color="white">mdi-account-file-outline</v-icon>Feratel </span>
              </v-col>
              <v-col cols="8" class="pl-4 mt-1 info text-right">
                <v-btn v-if="this.huov.Feratel_mblattnr == '' && this.huov.Feratel_guid == '' && this.huov.feratel_registration && this.huov.Feratel_betriebnr !== ''" x-small color="primary" class="mt-1 mr-4" @click="updFeratel('registration_final'); loader = 'loading'" :loading="loading">Create final registration</v-btn>
                <!-- pre registration gebruiken we niet
                <v-btn v-if="this.huov.Feratel_guid == '' && this.huov.Feratel_mblattnr == '' && this.huov.feratel_extra" x-small color="primary" class="mt-1 mr-4" @click="updFeratel('preregistration'); loader = 'loading'" :loading="loading">Create preregistration</v-btn>
                -->
              </v-col>
            </v-row> 
          </div>
          <div v-if="this.huov.Feratel_CompanyCode != '' && this.huov.feratel_extra && this.huov.Feratel_betriebnr !== ''">
            <v-row dense no-gutters>
              <v-col cols="4" class="pl-4 mt-1 info">
                <span class="white--text">
                  <v-icon medium class="mr-2 mt-1 mb-1" color="white">mdi-account-file-outline</v-icon>Feratel Extra Tests</span>
              </v-col>
              <v-col cols="8" class="pl-4 mt-1 info text-right">
                <!-- alleen update data is van belang
                <v-btn x-small color="secondary" class="mt-1 mr-4" @click="updFeratel('convert'); loader = 'loading'" :loading="loading">Convert preregistration</v-btn>
                <v-btn x-small color="secondary" class="mt-1 mr-4" @click="updFeratel('departure'); loader = 'loading'" :loading="loading">Set departure date</v-btn>
                <v-btn x-small color="secondary" class="mt-1 mr-4" @click="updFeratel('registration_final'); loader = 'loading'" :loading="loading">Create final registration</v-btn>
                -->
                <v-btn x-small color="secondary" class="mt-1 mr-4" @click="updFeratel('update'); loader = 'loading'" :loading="loading">Update data</v-btn>
              </v-col>
            </v-row> 
          </div>
          
          <div>
            <v-row dense no-gutters class="mb-2" v-if="this.huov.feratel_guestcard !== 'No Guestcards' && this.huov.feratel_guestcard !==''">
              <v-col cols="8" class="pl-4 pt-1 mt-1 info">
                <span class="white--text">
                  <v-icon medium class="mr-2 mt-1 mb-1" color="white">mdi-account-file-outline</v-icon>Feratel Guest card processing type: {{ this.huov.feratel_guestcard }}</span>
              </v-col>
              <v-col cols="4" class="pl-4 mt-1 info text-right">
                <v-checkbox dense color="white" v-model="huov.feratel_guestcard_processed"  @click="updFeratel('process_guestcard');">
                  <template v-slot:label>
                    <span style="color:white">
                      Guestcard sent to guest
                    </span>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row> 
          </div>
          <div v-if="this.huov.Feratel_CompanyCode != '' && this.huov.feratel_pdf.length > 0">
            <v-row dense no-gutters>
              <v-col cols="4" class="pl-4 mt-1">
                  <v-icon medium class="mr-2 mt-1 mb-1">mdi-account-file-outline</v-icon>Feratel Documents
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pl-4 mt-1">
                <v-simple-table>
                  <thead>
                    <tr>
                      <th class="text-left">Document</th>
                      <th class="text-left">Uploaded</th>
                      <th class="text-left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for='(pdf, idxpdf) in this.huov.feratel_pdf' :key='idxpdf'>
                      <td>{{ pdf.title }}</td>
                      <td>{{ pdf.uploaded }}</td>
                      <td><v-btn icon small @click="getPreviewFromServer(pdf, true)">
                                                                                <v-icon>mdi-card-search-outline</v-icon>
                                                                            </v-btn></td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row> 
          </div>
        </v-form>

        <v-card-actions>
          <v-btn v-if="this.huov.Feratel_mblattnr !== ''" x-small color="primary" class="mt-1 mr-4" :href="this.huov.feratel_registration_printlink" target="_blank" :loading="loading">Print Visitor registration form (Feratel)</v-btn>
          <v-btn v-if="this.huov.Feratel_mblattnr !== ''" x-small color="primary" class="mt-1 mr-4" @click="printRegistration()" :loading="loading">Print Visitor registration form (Ares)</v-btn>
          <v-spacer></v-spacer>
          <div style="color: red;">{{ this.saveError }}</div>
          <v-btn color="primary mx-2" small @click="updTravelParty">Save</v-btn>
          <v-btn color="primary" small @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import {bus} from "../../main";
import moment from 'moment';
import btn_audit from "@/components/ui/buttons/btn_audit.vue";

export default {
  data() { 
    return {
      dialog: false,
      pdffile: null,
      cancelregdialog: false,
      cancelpreregdialog: false,
      dialoguploadvrpdf: false,
      dialoguploadgcpdf: false,
      huov_encrid: null,
      id_codekeuzes: [],
      arrivalDate:'',
      loader: null,
      loading: false,
      errorText: '',
      saveError: '',
      huov: { feratel_pdf: [] },
      max_age_child: 17,
      max_age_baby: 2,
      hogs_geb_datRules: [
          v => (this.checkAge(v)) || this.errorText
      ],          
    }
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]
    },
  },
  components: {
    btn_audit
  },    
  methods: {
    open(huov_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.saveError=''
      this.$axios
        .post("ares/json/ares/huov/getHuovTravelParty.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovTravelParty",
          },
          getHuovTravelParty: {
            huov_encrid: huov_encrid,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuovTravelParty;
            // console.log(this.huov)
            this.max_age_baby = res.data.getHuovTravelParty.max_age_baby;
            this.max_age_child = res.data.getHuovTravelParty.max_age_child;
            this.id_codekeuzes = res.data.getHuovTravelParty.id_types;
            this.arrivalDate = res.data.getHuovTravelParty.iso_arr_dat;                  
            // console.log(this.huov.hogs)
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateTravelParty(huov_encrid) {
      this.huov_encrid = huov_encrid;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.saveError=''
      this.$axios
        .post("ares/json/ares/huov/getHuovTravelParty.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovTravelParty",
          },
          getHuovTravelParty: {
            huov_encrid: huov_encrid,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuovTravelParty;
            // console.log(this.huov)
            this.max_age_baby = res.data.getHuovTravelParty.max_age_baby;
            this.max_age_child = res.data.getHuovTravelParty.max_age_child;
            this.id_codekeuzes = res.data.getHuovTravelParty.id_types;
            this.arrivalDate = res.data.getHuovTravelParty.iso_arr_dat;                  
            // console.log(this.huov.hogs)
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setMainBooker(idx){
      for (let i = 0; i < this.huov.hogs.length; i++) {
        if (i !== idx){
          this.huov.hogs[i].hogs_hoofd_gast = false; // switch off all except the current (doesn't matter if it's off or on)
        }
      }              
    },
    isEmpty(idx){
       return this.huov.hogs[idx].hogs_geb_dat === '' &&
              this.huov.hogs[idx].hogs_naam === '' &&
              this.huov.hogs[idx].hogs_voornaam === '' &&
              this.huov.hogs[idx].hogs_id_type === '' &&
              this.huov.hogs[idx].hogs_id_type_oms === '' &&
              this.huov.hogs[idx].hogs_id_nr === ''
    },
    hasFullName(idx){
        return (this.huov.hogs[idx].hogs_naam !== '' && this.huov.hogs[idx].hogs_voornaam !== '');
    },
    checkAge(v){
      if(v===''){ // check if empty (not an error but not correct)
        this.errorText = ''
        return true
      }
      if(v.length!==10) { // show during typing
        this.errorText = 'DD-MM-YYYY'
        return false
      }
      if(v.length===10) { // check format
        let date1 = v.split("-");
        if(date1.length != 3){
          this.errorText = 'Invalid format'
          return false
        } else { // check max = 110 and min = 0
          let isodate1 = date1[2] + "-" + date1[1] + "-" + date1[0]
          let a = moment(isodate1) // birtdate
          let b = moment(this.arrivalDate)
          if(!a.isValid()){
            this.errorText = 'Invalid date'
            return false
          }
          if(a > b){
            this.errorText = 'Min age 0'
            return false
          }
          if (Math.abs(a.diff(b, 'years')) > 110) {
            this.errorText = 'Max age 110'
            return false
          }
        }       
      }
      return true
    },
    calculateAge(idx) {

      if(this.huov.hogs[idx].hogs_geb_dat === '' || this.huov.hogs[idx].hogs_geb_dat.length !== 10) return
      if(!this.checkAge(this.huov.hogs[idx].hogs_geb_dat)) return 

      let isodate = ''
      let tempCat = 'Baby'

      try {
        let tDate = this.huov.hogs[idx].hogs_geb_dat.split("-");
        isodate = tDate[2] + "-" + tDate[1] + "-" + tDate[0];
      } catch (err) {
        return ''; // no age can be determined 
      }
      let a = moment(isodate)
      let b = moment(this.arrivalDate)

      // check with category
      if (Math.abs(a.diff(b, 'years')) > this.max_age_child) {
        tempCat = 'Adult'            
      } else {
        if(Math.abs(a.diff(b, 'years')) > this.max_age_baby) {
          tempCat = 'Child'
        }            
      }    
      if (tempCat !== this.huov.hogs[idx].hogs_age_cat) {
         return 'CAT !'
      }
      return `(${Math.abs(a.diff(b, 'years'))} yr)`  // trick to create a string value 
    },        
    clearItem(idx){
      this.huov.hogs[idx].hogs_geb_dat = '';
      this.huov.hogs[idx].hogs_naam = '';
      this.huov.hogs[idx].hogs_voornaam = '';
      this.huov.hogs[idx].hogs_id_type = '';
      this.huov.hogs[idx].hogs_id_type_oms = '';
      this.huov.hogs[idx].hogs_hoofd_gast = false;
      this.huov.hogs[idx].hogs_id_nr = '';
    },
    notifyHuov(param) {
      bus.$emit("reloadHuov", param);
    },       
    refactorDate(person){
      let refdat = person.hogs_geb_dat;
      if(refdat.length === 10 ){
        refdat = refdat.replace("/", "-");
        refdat = refdat.replace(":", "-");
        refdat = refdat.replace(",", "-");
        refdat = refdat.replace("_", "-");
        refdat = refdat.replace(".", "-");
        person.hogs_geb_dat = refdat;
      }
    },  
    updTravelParty() {
      // console.log(this.huov.hogs);
      this.saveError = ''
      // first check all travelparty members to avoid saving lines with errors or incomplete lines
      for (let i = 0; i < this.huov.hogs.length; i++) {
        if(!this.isEmpty(i)){
          // if (this.checkAge(this.huov.hogs[i].hogs_geb_dat) && this.calculateAge(i)!=='CAT !' && this.hasFullName(i) &&  this.huov.hogs[i].hogs_geb_dat!=='') {
          if (this.checkAge(this.huov.hogs[i].hogs_geb_dat) && this.calculateAge(i)!=='CAT !') {
            console.log('line', i, 'ok')
          }
          else {
            this.saveError = `Line ${i+1} has an error and/or is not complete`
            setTimeout(() => { // make the error go away after 3 seconds
              this.saveError = ''
            }, 3000)
            return
          }
        }
      }      
      this.$axios
        .post("ares/json/ares/huov/updTravelParty2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updTravelParty",
          },
          updTravelParty: {
            huov_encrid: this.huov.huov_encrid,
            huov_aant_volw: parseInt(this.huov.huov_aant_volw),
            huov_aant_kind: parseInt(this.huov.huov_aant_kind),
            huov_aant_baby: parseInt(this.huov.huov_aant_baby),
            huov_aant_hd: parseInt(this.huov.huov_aant_hd),
            huov_hogs: this.huov.hogs,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.updTravelParty.text,
              color: res.data.updTravelParty.color,
            });
            if (res.data.updTravelParty.color == "success" || res.data.updTravelParty.color == "warning" ) {
              this.notifyHuov("travelparty");
            }
            this.dialog = false;
          }
        });
    },
    updFeratel(action){
      //console.log("Feratel",action,this.huov.Feratel_guid, this.huov.Feratel_mblattnr);
      this.$axios
        .post("ares/json/ares/huov/updFeratel.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updFeratel",
          },
          updFeratel: {
            huov_encrid: this.huov.huov_encrid,
            feratel_guestcard_processed: this.huov.feratel_guestcard_processed,
            action: action
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.updFeratel.text,
              color: res.data.updFeratel.color,
            });
            this.huov.Feratel_mblattnr = res.data.updFeratel.feratel_mblattnr;
            this.huov.Feratel_guid = res.data.updFeratel.feratel_guid;
            this.huov.feratel_guestcard_processed = res.data.updFeratel.feratel_guestcard_processed;
            this.huov.feratel_guestcard_printlink = res.data.updFeratel.feratel_guestcard_printlink;
            this.huov.feratel_registration_printlink = res.data.updFeratel.feratel_registration_printlink;

            this.loader = null;
            this.loading = false;
            //this.dialog = false;
          }
        });
    },
    saveFeratelPdf(pdffile,pdfname) {
      console.log('saveFeratelPdf',pdffile,pdfname)
      this.uploading = true;
      this.$axios
        .post("ares/json/ares/huov/saveFeratelPdf.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveFeratelPdf",
            'Content-Type': 'multipart/form-data'
          },
          saveFeratelPdf: {
            huov_encrid: this.huov.huov_encrid,
            pdf_file: pdffile,
            pdf_name: pdfname
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
             if (res.data.addHsft.color == "success") {
                //this.$router.reload('/huis/onHuis/' + res.data.addHsft.huis_encrid);  
                bus.$emit("closeDialog", "reload");
             }
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addHsft.text,
              color: res.data.addHsft.color
            }); 
            this.dialog = false;
          }
        })
    },
    getPreviewFromServer(item, direct_show) {
        item.isloading = true;
        this.$axios
            .post("ares/json/ares/misc/getAttachment.p", {
            header: {
                token: this.$session.get("ARES"),
                clientSessionId: this.$session.id(),
                request: "getAttachment"
            },
            getAttachment: {
                table: "huov",
                attm_nr: item.attm_nr,
            }
            })
            .then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.preview = res.data.getAttachment;
                    if(direct_show){
                        this.previewFileByUrl(this.preview.url);                                
                    }
                }
            })
            .finally(() => {item.isloading = false;});
    }, 
    previewFileByUrl(url){
                window.open(url,'_blank');
            },
    printRegistration() {
      this.loading = true;
      this.$axios
        .post("ares/json/ares/huov/printFeratelRegistration.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "printFeratelRegistration",
          },
          printFeratelRegistration: {
            huov_encrid: this.huov.huov_encrid,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.printFeratelRegistration.text,
              color: res.data.printFeratelRegistration.color,
            });
            let item = {
              attm_nr: res.data.printFeratelRegistration.pdf,
              title: "Feratel Registration",
              isloading: false
            };
            this.updateTravelParty(this.huov.huov_encrid);
            this.getPreviewFromServer(item, true);
          }
        })
        .finally(() => {this.loading = false;});
    }
  },
  
};
</script>

<style scoped>
.br_small {
    display: block;
    margin-bottom: 1em;
}
.def {
  cursor: default;
}  
.travelpadd {
  padding-left: 16px;
  padding-right: 16px;
}
.margin-btn {
  margin-top: 10px;
  margin-left: 10px;
}  
.caterror >>> input {
  color: red !important;
  font-weight: 800 !important;
}
</style>

